import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	syncedIntegrationsTableIntegrationNameHeadNonFinal: {
		id: 'eoc-changeboarding.transition-home.integrations-step.synced-integrations-table.synced-integrations-table-integration-name-head-non-final',
		defaultMessage: 'Sync',
		description: 'Transition home synced integrations step table integration name head',
	},
	syncedIntegrationsTableTeamNameHeadNonFinal: {
		id: 'eoc-changeboarding.transition-home.integrations-step.synced-integrations-table.synced-integrations-table-team-name-head-non-final',
		defaultMessage: 'Team name',
		description: 'Transition home synced integrations step table team name head',
	},
	syncedIntegrationCountNonFinal: {
		id: 'eoc-changeboarding.transition-home.integrations-step.synced-integrations-table.synced-integration-count-non-final',
		defaultMessage:
			'{count, plural, one {{count} Opsgenie integration} other {{count} Opsgenie integrations}} are now syncs:',
		description: 'Transition home synced integrations count',
	},
});
